import React from "react";
const Profile = () => {
    const userString = localStorage.getItem('user');
    const user = userString ? JSON.parse(userString) : {username:'Guest'};
    return (
        <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
            <h2>User Profile</h2>
            
            <div style={{ 
                backgroundColor: '#f9f9f9', 
                padding: '20px', 
                borderRadius: '8px', 
                border: '1px solid #ddd',
                marginTop: '20px'
            }}>
                <h3 style={{ margin: '0 0 10px 0' }}>Account Details</h3>
                <p><strong>Username:</strong> {user.username}</p>
                <p><strong>Account Role:</strong> {user.role ? user.role.toUpperCase() : 'USER'}</p>
                
                {/* We can add more stats here later, like "Total Tournaments Played"! */}
                <p style={{ color: '#666', fontStyle: 'italic', marginTop: '20px' }}>
                    More account statistics coming soon...
                </p>
            </div>
        </div>
    )
};

export default Profile;